<script lang="ts">
  import Gift from "./Gift.svelte";
  import ActivityBadge from "./ActivityBadge.svelte";
  import { giftsConfig } from "../config/gifts";
  import {
    BackgroundDimensions,
    assetsProgress,
    selectedActivityIndex,
  } from "../store/AppState";

  export let onLoad: () => void;

  $: loadedCounter = 0;

  const handleGiftLoad = () => {
    loadedCounter++;
    $assetsProgress += 1;
    if (loadedCounter === giftsConfig.length) {
      onLoad();
    }
  };

  const handleActivityBadgeOpen = (index: number) => {
    selectedActivityIndex.set(index);
  };

  const handleActivityBadgeClose = () => {
    selectedActivityIndex.set(null);
  };
</script>

<div
  class="gifts-container"
  style={`z-index: ${$selectedActivityIndex !== null ? "300" : "1"}`}
>
  {#if $selectedActivityIndex !== null}
    <ActivityBadge handleClose={handleActivityBadgeClose} />
  {/if}
  {#each giftsConfig as item, index}
    <Gift
      onClick={() => handleActivityBadgeOpen(index)}
      config={item}
      {index}
      onLoad={() => handleGiftLoad()}
      zIndex={$selectedActivityIndex !== null ? "300" : "30"}
    />
  {/each}
  <img
    class="zar"
    src={`${__PUBLIC_PATH__}images/darky_zare.svg`}
    alt="Darkozar"
    width={`${$BackgroundDimensions.width}px`}
    height={`${$BackgroundDimensions.height}px`}
    style={`z-index: ${
      $selectedActivityIndex !== null ? "20" : "1"
    }; --height: ${
      __MODE__ === "production" ? "calc(100dvh - 6.4rem)" : "100dvh"
    }`}
  />
</div>

<style>
  .zar {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
  }
</style>
